import { call, put, takeEvery } from 'redux-saga/effects'
import * as notificationActions from '../ducks/notificationDucks'
import * as notificationApi from '@api/notificationApi'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListNotification({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof notificationApi.getListNotification> = yield call(notificationApi.getListNotification, queryString)
    yield put(notificationActions.getListNotificationSuccess(res))
  } catch (error) {
    yield put(notificationActions.getListNotificationFail(error))
  }
}

function* fetchListOptionNotification({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof notificationApi.getListOptionNotification> = yield call(notificationApi.getListOptionNotification, queryString)
    yield put(notificationActions.getListOptionNotificationSuccess(res))
  } catch (error) {
    yield put(notificationActions.getListOptionNotificationFail(error))
  }
}


export default function* watchMenu() {
  yield takeEvery(notificationActions.getListNotification.toString(), fetchListNotification)
  yield takeEvery(notificationActions.getListOptionNotification.toString(), fetchListOptionNotification)
}
